import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/lato-regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/lato-italic.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22},{%22path%22:%22../../public/fonts/lato-bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22}],%22declarations%22:[{%22prop%22:%22font-family%22,%22value%22:%22Lato%22},{%22prop%22:%22unicode-range%22,%22value%22:%22U+0000-00FF,%20U+0131,%20U+0152-0153,%20U+02BB-02BC,%20U+02C6,%20U+02DA,%20U+02DC,%20U+2000-206F,%20U+2074,%20U+20AC,%20U+2122,%20U+2191,%20U+2193,%20U+2212,%20U+2215,%20U+FEFF,%20U+FFFD%22}],%22preload%22:false,%22variable%22:%22--font-lato-latin%22}],%22variableName%22:%22latoLatin%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'latoLatin', 'latoLatin Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
